import React, {FC} from 'react'
import {CellPropsType} from './cellPropsType'
import {DatabaseMetadata} from 'graphql-api'

import {Icon} from '@mdsol/onex-design'

const Active: FC<CellPropsType> = ({cell}) => {
  const isActive = cell.getValue()
  const {databaseId} = cell.row.original as DatabaseMetadata
  return <>
    {
      isActive ?
        <Icon
          id={`active-database-id-${databaseId}`}
          className='is-active text-primary'
          key='database-is-active-check'
          role='database-is-active-check-icon'
        >
          check
        </Icon>
        :
        <Icon
          id={`active-database-id-${databaseId}`}
          className='is-not-active'
          key='database-is--not-active-check'
          role='database-is-not-active-check-icon'
        >
          close
        </Icon>
    }
  </>
}

export default Active
